import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=60dd66fc&scoped=true"
import script from "./CardBox.vue?vue&type=script&lang=js"
export * from "./CardBox.vue?vue&type=script&lang=js"
import style0 from "./CardBox.vue?vue&type=style&index=0&id=60dd66fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd66fc",
  null
  
)

export default component.exports